// extracted by mini-css-extract-plugin
export default {"commentBox":"K2IQMl","withPadding":"WooxTX"};